import { Link } from 'react-router-dom';

interface LoginLinkProps {
  route: string;
  text?: string;
  error?: boolean;
}

export default function LoginLink({ route, text, error }: LoginLinkProps) {
  return (
    <>
      <p className={error ? 'Signup__Error' : 'Signup__Login_Link_Text'}>
        {text}
      </p>
      <p>
        <Link className="Signup__Login_Link" to={route}>
          Log in
        </Link>
      </p>
    </>
  );
}
